import { Input } from "@legal-500/legal500-design-system";
import { Controller } from "react-hook-form";
import type { Control, FieldErrors } from "react-hook-form";
import type { FormFieldConfig } from "../../../types/uiTypes";
import styles from "../forms/GenericForm.module.css";

type TextFieldProps = {
  field: FormFieldConfig;
  control: Control<Record<string, unknown>>;
  errors: FieldErrors<Record<string, unknown>>;
};

export function TextField({ field, control, errors }: TextFieldProps) {
  const error = errors[field.name]?.message;
  const errorMessage = typeof error === "string" ? error : undefined;
  const errorId = `${field.name}-error`;
  const helperId = `${field.name}-helper`;
  const describedBy = errorMessage ? errorId : field.helperText ? helperId : undefined;

  return (
    <div className={styles.formField}>
      <label htmlFor={field.name} className={styles.label}>
        {field.label}{" "}
        {field.required && (
          <span className={styles.required} aria-hidden="true">
            *
          </span>
        )}
      </label>
      <Controller
        name={field.name}
        control={control}
        render={({ field: controllerField }) => (
          <div>
            <Input
              {...controllerField}
              id={field.name}
              value={controllerField.value as string}
              placeholder={field.placeholder}
              disabled={field.disabled}
              aria-invalid={!!errorMessage}
              aria-describedby={describedBy}
              aria-required={field.required}
            />
            {errorMessage && (
              <span id={errorId} className={styles.errorText} role="alert" aria-live="polite">
                {errorMessage}
              </span>
            )}
            {field.helperText && !errorMessage && (
              <span id={helperId} className={styles.helperText}>
                {field.helperText}
              </span>
            )}
          </div>
        )}
      />
    </div>
  );
}
